module.exports = __webpack_public_path__ + "static/homelander-d2bda2a35139b605a0b625bdcbf68e63.jpg";